/** Copie locale d'un rapport passé à un collègue.

On ne l'efface que si le serveur confirme le transfert de CE rapport
(status « transferred » et même identifiant). Une erreur réseau, un refus ou
une réponse « unknown » gardent la copie. Les autres brouillons ne sont pas vus.
*/
export function transferredDraftDecision(local, ownership) {
  const localId = String(local?.data?.id || '').trim();
  if (!localId) return { clear: false };
  if (!ownership || typeof ownership !== 'object' || ownership.status !== 'transferred') return { clear: false };
  if (String(ownership.report_id || '').trim() !== localId) return { clear: false };
  const who = String(ownership.to_agent_name || '').trim();
  return {
    clear: true,
    reportId: localId,
    toAgentName: who,
    // « Laurent G. » finit déjà par un point.
    message: who ? `Ce rapport a été transféré à ${who}${who.endsWith('.') ? '' : '.'}` : 'Ce rapport a été transféré à un collègue.',
  };
}

/** Réponse 409 « report_transferred » du serveur : une confirmation explicite. */
export function ownershipFromConflict(detail) {
  if (!detail || typeof detail !== 'object' || detail.code !== 'report_transferred') return null;
  return {
    status: 'transferred',
    report_id: String(detail.report_id || ''),
    to_agent_name: String(detail.to_agent_name || ''),
  };
}

/** Que faire d'un refus pendant la synchro automatique ?
- « check » : demander au serveur si le rapport a été transféré (409 ou 403) ;
- « merge » : vrai conflit entre appareils du même agent (409 avec la version du serveur) ;
- « keep » : autre erreur ou réseau : on garde la copie et on réessaiera.
*/
export function syncFailureAction(status, detail) {
  if (status !== 409 && status !== 403) return 'keep';
  if (status === 409 && detail && typeof detail === 'object' && detail.code !== 'report_transferred' && 'data' in detail) {
    return 'check-then-merge';
  }
  return 'check';
}
